export enum ConfirmationResult {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  DENIED = 'DENIED',
  INACTIVE = 'INACTIVE'
}

export interface Confirmation {
  confirmations: {[playerId: string]: boolean},
  target: number,
  confirmed: number,
  denied: number,
  result: ConfirmationResult
}
